import { toast as sonnerToast } from 'sonner'

const isMuted = () => {
  try { return !!(window && window.__MUTE_SOUNDS) }
  catch(e){ return false }
}

const wrap = (fn) => (...args) => {
  if (isMuted()) return
  return fn(...args)
}

export const toast = {
  success: wrap(sonnerToast.success),
  error: wrap(sonnerToast.error),
  info: wrap(sonnerToast.info || (msg=>sonnerToast(msg))),
  warning: wrap(sonnerToast.warning || (msg=>sonnerToast(msg))),
  // fallback to raw toast if used elsewhere
  raw: sonnerToast,
}

export default toast
